import { useQuery } from 'react-query'
import { fetchWrapper } from 'utils/fetchWrapper'
import toastr from 'react-hot-toast'
import { CACHE_AND_STALE_TIME } from 'constants/index'

import type { StripeInvoice } from 'types/Stripe/StripeInvoices'

const getStripeInvoices = (marketplaceAccountID: string | undefined) => {
  if (!marketplaceAccountID) {
    Promise.reject('Marketplace Account ID can not be null')
    return
  }
  // this is NOT JSON api end point
  return fetchWrapper<StripeInvoice[]>({
    url: `stripe/invoices?MarketplaceAccountID=${marketplaceAccountID}&sort=-created`,
    method: 'GET',
  })
}

export function useStripeInvoices(marketplaceAccountID: string | undefined) {
  return useQuery(
    ['stripeInvoices', marketplaceAccountID],
    () => getStripeInvoices(marketplaceAccountID),
    {
      onError: (error) => {
        if (error instanceof Error) {
          toastr.error(`failed to Fetch invoices: ${error.message}`)
        }
      },
      enabled: Boolean(marketplaceAccountID),
      ...CACHE_AND_STALE_TIME,
    }
  )
}
